export default __webpack_public_path__ + "static/media/slider-img20.42d06ab1.jpg";